<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { reactive, ref, defineProps, defineEmits, watch } from 'vue';
    import { PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    const props = defineProps({
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
    });
    const emit = defineEmits(['update:modelValue']);
    const loading = ref(false);
    const formData = reactive({
        type_promotion: null as string | null,
        montant_promotion: 0
    });

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });
</script>

<template>
    <div>
        <h5 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            Gestion des promotions
        </h5>

        <div class="form-field-floating full my-5">
            <select class="form-input-select" v-model="formData.type_promotion" name="type_promotion" id="type_promotion">
                <option :value="null">Aucune promotion</option>
                <option :value="type_promotion.value" v-for="(type_promotion, index) in startupFormDatas.types_promotion" :key="'type_promotion_' + index">
                    {{ type_promotion.label }}
                </option>
            </select>
            <label for="type_promotion">Type promotion <b class="color-danger">*</b></label>
        </div>

        <template v-if="formData.type_promotion == 'PERCENTAGE'">
            <div class="form-field-floating full my-5">
                <money3 class="form-input" v-model="formData.montant_promotion" name="montant_promotion" id="montant_promotion" placeholder="" v-bind="PERCENTAGE_FORMAT_CONFIG"></money3>
                <label for="pourcentage">Pourcentage de réduction (%) <b class="color-danger">*</b></label>
            </div>
        </template>
    </div>
</template>
